import type { ManualMatchRule } from "./programmeDiff";

export function getManualMatchesForComparison(
  oldSnapshotId: string,
  newSnapshotId: string,
): ManualMatchRule[] {
  if (oldSnapshotId === "2025-10" && newSnapshotId === "2026-06") {
    return [
      {
        old: { project: "Granton Liveable Neighbourhood", phase: "General" },
        new: { project: "Granton Liveable Neighbourhood", phase: null },
      },
      {
        old: { project: "Roseburn to Union Canal Phase 2", phase: "General" },
        new: {
          project: "Roseburn to Union Canal",
          phase: "Phase 2: Russell Road and Telfer subway ramp",
        },
      },
    ];
  }

  return [];
}
